/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),
    
    
     $mobileNavTrigger2: $('#MobileNavTrigger2'),
    $mobileNav2: $('#MobileNav2'),
    $mobileSublistTrigger2: $('.mobile-nav__sublist-trigger2'),
    
    

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note'
  }
};

theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav(); 
   theme.mobileNav2(); 
  theme.cartPage();
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger2.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};


theme.mobileNav2 = function () {
  theme.cache.$mobileNavTrigger2.on('click', function() {
    theme.cache.$mobileNav2.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger2.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};



theme.cartPage = function () {
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });
};

// Initialize theme's JS on docready
$(theme.init)

// 
$(window).bind("load", function() {
  $(document).ready(function() {
    $("span.cf-label.cf-title").each(function(i) {
        $(this).attr('id', "title-filter" + (i + 1));
    });
  
    $("span.cf-options-container").each(function(i) {
        $(this).attr('id', "container-filter" + (i + 1));
    });
  

  
    $("span.cf-options-container").each(function(i) {
        $(this).hide();
    });
  
    
  
    $("#title-filter1").addClass("active");
    $("#container-filter1").show();
    $("span.cf-options-container.active").show();
  
  
    $("span.cf-label.cf-title").click(function(){
      $("span.cf-label.cf-title").removeClass("active");
      $("span.cf-options-container").hide();
      $(this).addClass("active");
      $(this).next().show();

    }) 
  });




});

